import { createI18n, type I18nOptions } from 'vue-i18n'
import en from './locales/en.json'
import pl from './locales/pl.json'

export type MessageSchema = typeof pl

const options: I18nOptions = {
    legacy: false,
    locale: 'pl',
    fallbackLocale: 'en',
    numberFormats: {
        pl: {
            decimal: {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: 2,
            },
        },
        en: {
            decimal: {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: 2,
            },
        },
    },
    messages: {
        en,
        pl,
    },
}

const i18n = createI18n<false, typeof options>(options)
export default i18n
